// Decode a JWT's payload (claims) safely.
//
// JWTs are base64URL-encoded, whose alphabet uses `-` and `_` in place of `+`
// and `/` and omits `=` padding. Plain `atob()` only accepts standard base64,
// so it throws "The string contains invalid characters" whenever a payload
// happens to contain a `-` or `_` — which is data-dependent on the claim bytes,
// making the failure intermittent (some tokens decode, others crash).
//
// This normalizes base64URL → base64, restores padding, then decodes the
// bytes as UTF-8. Returns
// the parsed claims object, or null for a missing/malformed token so callers
// can decide how to handle a bad token rather than crashing the page.
export const decodeJwtClaims = accessToken => {
  if (!accessToken || typeof accessToken !== 'string') return null

  const parts = accessToken.split('.')
  if (parts.length < 2 || !parts[1]) return null

  try {
    let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const padding = base64.length % 4
    if (padding) base64 += '='.repeat(4 - padding)

    // atob() returns one Latin-1 character per byte; the payload is UTF-8
    // JSON, so decode the bytes as UTF-8 (otherwise "—" reads "â€\u0094").
    const binary = atob(base64)
    const bytes = Uint8Array.from(binary, c => c.charCodeAt(0))
    return JSON.parse(new TextDecoder('utf-8').decode(bytes))
  } catch (e) {
    return null
  }
}

// A bounded LMS session's token (Phase F, F-5): the lms-launch client, or the
// launch claim whatever the client says. The viewer and the app use these;
// the admin never stores or uses one (storage/auth.js).
export const isLaunchToken = accessToken => {
  const claims = decodeJwtClaims(accessToken)
  return !!claims && (claims.client === 'lms-launch' || (claims.launch !== undefined && claims.launch !== null))
}
